import { cn } from '../../utils/cn';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../utils/components/ui/table';

type Column = {
  header: string;
  accessor: string;
  className?: string;
  cell?: (cell: {
    row: { original: Record<string, string> };
    value: string;
  }) => React.ReactNode;
};

type Props = {
  caption?: string;
  columns: Column[];
  data: Record<string, string>[];
};

function TableComponent({ columns, data }: Props) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          {columns.map((column, index) => (
            <TableHead
              key={index}
              className={`bg-[#F3F4F3] text-[14px] font-[400] ${column.className}`}
            >
              {column.header}
            </TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody className='overflow-y-auto max-h-[85vh]'>

        {data.length > 0 ? (
          data.map((row, rowIndex) => (
            <TableRow key={rowIndex} className="bg-white">
              {columns.map((column, colIndex) => {
                // Get the cell content
                const cellContent = column.cell
                  ? column.cell({
                    row: { original: row }, // Match the structure expected by cell renderers
                    value: row[column.accessor],
                  })
                  : row[column.accessor];

                return (
                  <TableCell
                    key={colIndex}
                    className={cn(
                      'lg:h-[42px] xl:max-h-[45px] 3xl:h-[60px] text-start',
                      column.accessor === 'description' ? 'text-[#4F6059] ' : '',
                      column.className
                    )}
                  >
                    {cellContent}
                  </TableCell>
                );
              })}
            </TableRow>
          ))
        ) : (
          <TableRow className="bg-white h-[90%]">
            <TableCell
              colSpan={columns.length}
              className="text-center text-slate-500 "
            >
              No data to display
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
}

export default TableComponent;
